import { createAsyncThunk } from '@reduxjs/toolkit';
import { getWarehouse, putWarehouseInfo } from 'services/api';

export const getWarehouseAsync: any | null = createAsyncThunk(
  'warehouseDetail/getWarehouse',
  async (data: any) => {
    const response = await getWarehouse(data);
    return response;
  },
);

export const putWarehouseInfoAsync: any | null = createAsyncThunk(
  'warehouseDetail/putWarehouseInfo',
  async (data: any) => {
    const { devices, ...payload } = data; // quitamos devices para el request
    const response = await putWarehouseInfo(payload.id, payload);
    return response;
  },
)
